const config = {
    REACT_APP_API_BASE_URL: API_BASE_URL,
    REACT_APP_NEW_CONVERSATION_SOCKET: SOCKET_BASE_URL,
    REACT_APP_ASSETS_BASE_URL: ASSETS_BASE_URL,
    REACT_APP_CONVERSATION_WIDGET_URL: CONVERSATION_WIDGET_URL,
    REACT_APP_TEST_AID: '61201c1570c9490009dc5a14',
};

export default config;
